import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { clsx } from 'clsx';

interface Props {
  showInvoicesTab: boolean;
  retailerId: string | undefined;
}

const DahsboardInnerNavigation: React.FC<Props> = memo(
  ({ showInvoicesTab, retailerId }) => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigate = (slug: string) => {
      const url = `/${retailerId}/documents/${slug}`;
      navigate(url);
    };

    const matchRoute = (slug: string) => {
      return location.pathname.includes(slug);
    };

    const pages = useMemo(() => {
      const allPages = [
        { name: t('orders.title'), slug: 'orders' },
        // { name: t('orders.documents.title'), slug: 'documents' },
        { name: t('invoices.title'), slug: 'invoices' },
        { name: t('contracts.title'), slug: 'contracts' },
      ];
      return showInvoicesTab
        ? allPages
        : allPages.filter((page) => page.slug !== 'invoices');
    }, [showInvoicesTab, t]);

    return (
      <div
        className="w-full bg-grey-100 font-li flex p-0-4 rounded-8-0 text-2-0 md:text-1-4 my-2-0"
        id="dashboardNavigation"
      >
        {pages.map((page) => (
          <div
            className={clsx(
              matchRoute(page.slug) &&
                'text-primary-black bg-primary-white rounded-8-0 shadow',
              'px-1-2 py-0-8 text-grey-700 mr-1-0 cursor-pointer transition-bg duration-200 ease-linear',
            )}
            key={page.slug}
            onClick={() => handleNavigate(page.slug)}
          >
            {page.name}
          </div>
        ))}
      </div>
    );
  },
);

export default DahsboardInnerNavigation;
